module.exports = __webpack_public_path__ + "img/kuaishou1.7df03360.png";